<div class="page-not-found">
    <div class="mat-display-4">
        <span>500</span>
    </div>
    <h2>Internal Server Error</h2>
    <h3>Error code: 504. Please try again letter.</h3>
    <br>
    <button mat-flat-button type="button" color="accent" [routerLink]="['/']">Go to home</button>
</div>